'use client';

import { useState } from 'react';
import { Monitor, Smartphone, Compass, Lock } from 'lucide-react';
import LoginModal from '@/components/auth/LoginModal';

/**
 * Landing "app in arrivo" mostrata su mobile in modalità blocco navigazione.
 * OVERLAY full-screen (fixed inset-0, z-80 → sopra la navbar z-70) → l'utente vede
 * SOLO questa. Lucchetto in basso → apre il MODALE di login (z-100, sopra la landing)
 * senza uscire dalla landing (niente navigazione al sito).
 */
export default function V3MobileNotice() {
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <div
      data-cid="v3-mobile-notice"
      className="fixed inset-0 z-[80] flex items-center justify-center px-6 py-16 overflow-hidden bg-gradient-to-b from-sky-900 via-blue-950 to-slate-950"
    >
      {/* riflessi soft */}
      <div aria-hidden className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 left-1/4 w-72 h-72 rounded-full bg-cyan-500/10 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full bg-blue-500/10 blur-3xl" />
      </div>

      {/* Dimensioni PROPORZIONALI alla viewport (clamp con vw): la resa è identica
          su ogni telefono, a prescindere dalla larghezza CSS reale del device (px
          fissi apparivano piccoli sui Samsung ad alta risoluzione = viewport più larga).
          Vedi regola feedback_mobile_fixed_size. */}
      <div className="relative w-full text-center" style={{ maxWidth: 'min(92vw, 30rem)' }}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src="/logo-h.png" alt="Insula Charter" className="w-auto object-contain mx-auto brightness-0 invert" style={{ height: 'clamp(2.5rem, 12vw, 3.5rem)', marginBottom: 'clamp(1.5rem, 8vw, 2.5rem)' }} />

        <div className="inline-flex items-center justify-center gap-2 text-cyan-300/90" style={{ marginBottom: 'clamp(1.25rem, 6vw, 2rem)' }}>
          <Smartphone style={{ width: 'clamp(20px, 6vw, 26px)', height: 'clamp(20px, 6vw, 26px)' }} strokeWidth={1.6} />
          <span className="h-px bg-cyan-300/40" style={{ width: 'clamp(1.5rem, 8vw, 2rem)' }} />
          <Monitor style={{ width: 'clamp(24px, 7vw, 30px)', height: 'clamp(24px, 7vw, 30px)' }} strokeWidth={1.6} />
        </div>

        <h1 className="text-white font-black leading-tight mb-3" style={{ fontSize: 'clamp(1.5rem, 7.5vw, 2.25rem)' }}>
          Stiamo costruendo l&apos;app dedicata
        </h1>
        <p className="text-white/75 leading-relaxed mb-3" style={{ fontSize: 'clamp(1rem, 4.4vw, 1.15rem)' }}>
          La nuova esperienza di navigazione è ottimizzata per <strong className="text-white">desktop</strong>.
          Per esplorare barche ed esperienze al meglio, ti consigliamo di tornare da computer.
        </p>
        <p className="text-white/55 leading-relaxed" style={{ fontSize: 'clamp(0.85rem, 3.6vw, 0.95rem)' }}>
          L&apos;app per smartphone e tablet arriverà presto.
        </p>

        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/15 text-white/80 font-bold uppercase tracking-widest" style={{ marginTop: 'clamp(1.75rem, 9vw, 2.5rem)', fontSize: 'clamp(0.65rem, 2.8vw, 0.75rem)' }}>
          <Compass size={14} className="text-emerald-300" />
          Sardegna · Mediterraneo
        </div>
      </div>

      {/* Lucchetto: apre il login in un MODALE (resta sulla landing) */}
      <button
        type="button"
        onClick={() => setLoginOpen(true)}
        data-cid="v3-mobile-admin-login"
        aria-label="Accesso gestionale"
        className="absolute bottom-[calc(1rem+env(safe-area-inset-bottom))] right-4 z-10 inline-flex items-center justify-center w-11 h-11 rounded-full bg-white/10 border border-white/15 text-white/70 hover:bg-white/20 hover:text-white transition-colors"
      >
        <Lock size={18} />
      </button>

      <LoginModal isOpen={loginOpen} onClose={() => setLoginOpen(false)} />
    </div>
  );
}
